import { useId } from "react";

interface IcoDownProps {
    className?: string;
}

function IcoDown({ className }: IcoDownProps = {}) {
    const id = useId();
    return (
        <svg className={className} width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath={`url(#clip0_323_21_down_${id})`}>
            <path d="M12.2505 5.35485e-07L6.50177 5.54949L0.749523 3.27627e-08L2.74352e-07 0.723549L6.50177 7L13 0.72355L12.2505 5.35485e-07Z" fill="currentColor"/>
            </g>
            <defs>
            <clipPath id={`clip0_323_21_down_${id}`}>
            <rect width="7" height="13" fill="white" transform="translate(13) rotate(90)"/>
            </clipPath>
            </defs>
        </svg>
    );
}

export default IcoDown;